import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { WorksheetComponent } from './worksheet.component';

const routes: Routes = [
  {
    path: '',
    component: WorksheetComponent,
    canActivate: [MsalGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorksheetRoutingModule {}
